/**
 * Единая шкала z-index для элементов с управляемым наложением:
 * sticky-элементы страницы, React-порталы (document.body), MUI Drawer/Modal,
 * глобальный FAB поддержки в App.
 *
 * Правило: любой полноэкранный оверлей/дровер чата должен быть ВЫШЕ supportFab/supportMenu,
 * иначе синяя кнопка и меню будут перекрывать чат.
 *
 * Добавляйте новые уровни только сюда и импортируйте по имени.
 */
export const UI_LAYER_STICKY_TAB_SELECTOR = 5
/** Обычные попапы приложения в document.body - выше локальных sticky-элементов */
export const UI_LAYER_POPUP = 10000
/** Попап, который открывается поверх уже открытого обычного попапа (вложенные диалоги) */
export const UI_LAYER_POPUP_OVER_POPUP = UI_LAYER_POPUP + 1

export const UI_LAYER_SUPPORT_FAB = 210000
export const UI_LAYER_SUPPORT_FAB_BADGE = UI_LAYER_SUPPORT_FAB + 1
/** Глобальная плашка уведомлений (store notification в App) — выше FAB */
export const UI_LAYER_GLOBAL_NOTIFICATION = 220000
/** Popover меню из FAB поддержки */
export const UI_LAYER_SUPPORT_MENU = 230000
/** Панель справочного центра (глобальный дровер из FAB) — между меню и чатами */
export const UI_LAYER_HELP_CENTER = 235000
/** Боковые панели чатов (ИИ шаблона, помощь при подписании) — выше FAB и меню */
export const UI_LAYER_CHAT_DRAWER = 240000
/** Модалки/попапы, которые должны открываться поверх уже открытого чата */
export const UI_LAYER_CHAT_DIALOG = 250000
/**
 * Выпадающие меню/пикеры (например, выбор источника фото в EntityInput),
 * которые открываются из попапов/диалогов и обязаны быть выше них.
 */
export const UI_LAYER_DROPDOWN_OVER_POPUP = 260000
